import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { ProductSection } from '../components/ProductSection';
import { BonusesSection } from '../components/BonusesSection';
import { OfferSection } from '../components/OfferSection';
import { UpsellSection } from '../components/UpsellSection';
import { LongTestimonials } from '../components/LongTestimonials';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { CostSection } from '../components/CostSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { PurchasePopups } from '../components/PurchasePopups';
export type SalesPageProps = {
  showReviews: boolean;
  showPurchasePopups: boolean;
  showCountdown: boolean;
  showExtrasOffer: boolean;
  guaranteeEnabled: boolean;
};
export function SalesPage({
  showReviews,
  showPurchasePopups,
  showCountdown,
  showExtrasOffer,
  guaranteeEnabled
}: SalesPageProps) {
  const offerProps = {
    showCountdown,
    showExtrasOffer,
    guaranteeEnabled
  };
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-291" data-mp="35qx4c2tsouu7">
      <Hero guaranteeEnabled={guaranteeEnabled} data-id="element-292" data-mp="30u6onglwk19b" />
      <main data-id="element-293" data-mp="2vvc70hzo8iqs">
        <PainSection data-id="element-294" data-mp="2vvlotiakbjle" />
        <ProductSection data-id="element-295" data-mp="2vwexwpwzul6p" />
        <BonusesSection data-id="element-296" data-mp="2vsr5ju3ac4tk" />
        <OfferSection variant="launch" {...offerProps} data-id="element-297" data-mp="3tic8m154tm83" />
        {showExtrasOffer && <UpsellSection data-id="element-298" data-mp="3tg89dwi6hbe5" />}
        {showReviews && <LongTestimonials data-id="element-299" data-mp="3oj82jjdi84lz" />}
        {guaranteeEnabled && <GuaranteeSection data-id="element-300" data-mp="3oher7qry4w7n" />}
        <FAQSection data-id="element-301" data-mp="3jk4wbvlsfscf" />
        <CostSection data-id="element-302" data-mp="3jjdavdlwnazv" />
        <OfferSection variant="final" {...offerProps} data-id="element-303" data-mp="3jittby062omd" />
        <ClosingSection data-id="element-304" data-mp="3fjclixx9pfe1" />
      </main>
      <Footer data-id="element-305" data-mp="3fi9ves7rrgz6" />
      {showPurchasePopups && <PurchasePopups data-id="element-306" data-mp="2859igbuytuwx" />}
    </div>;
}